import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Layout from "./Layout";
import { Row, Col } from "reactstrap";
import styled from "styled-components";
import Services from "./Services";
import Testimonial from "./Testimonial";
import Faqs from "../components/faqs/Faqs";
import { submit, isInvalid } from "redux-form";
import StepOne from "./StepOne";
import WizardForm from "./WizardForm";
import { notify } from "reapop";
require("dotenv").config();

class App extends Component {
  state = {
    step: 1,
    type: "juridica",
    data: []
  };

  onSubmit = values => {
    if (this.state.data.length === 0) {
      this.props.notify({
        title: "Error!",
        message: "Debe agregar al menos una cedula.",
        status: "error",
        position: "tr",
        duration: 5000
      });
    }
  };

  changeType = type => this.setState({ type });

  changeStep = step => this.setState({ step });

  changeData = data =>
    this.setState({
      data: [...this.state.data, data]
    });

  deleteCedule = index => {
    const original = this.state.data.map(el => el);

    original.splice(index, 1);

    this.setState({
      data: original
    });
  };

  redirectToStep = step => {
    if (step === 2) {
      this.props.submit("wizard");
      if (!this.props.isInvalid) this.setState({ step });
    } else {
      this.changeStep(1);
    }
  };

  render() {
    const { step } = this.state;
    const imageCedula = require("../assets/images/cedula-azul-ejemplo.png");

    return (
      <Fragment>
        <Layout>
          <h1 className="main-title">
            CEDULA AZUL O VERDE EN MINUTOS
          </h1>
          <div className="container board-tramite pt-4 pb-1">
            <ol className="breadcrumb-custom bread-desktop">
              <li
                onClick={() => this.redirectToStep(1)}
                className={
                  step === 1 ? "breadcrumb-level-active" : "breadcrumb-level"
                }>
                <a className="font-step">DATOS DE SOLICITANTE</a>
              </li>
              <li
                onClick={() => this.redirectToStep(2)}
                className={
                  step === 2 ? "breadcrumb-level-active" : "breadcrumb-level"
                }>
                <a className="font-step">DATOS DE CEDULA</a>
              </li>
            </ol>

            <Row className="mt-5">
              <Col md={{ size: 8, offset: 2 }}>
                {this.state.step === 1 && (
                  <StyledTitle
                  className="font-size-mobile-title" 
                  align="center"
                  background="#F2F2F2">
                    TARJETA DE SOLICITUD DE CIRCULACIÓN
                  </StyledTitle>
                )}
                {this.state.step === 2 && (
                  <StyledTitle 
                  className="font-size-mobile-title" 
                  align="center"
                  background="#F2F2F2">
                    DATOS DEL TITULAR/DUEÑO DEL VEHÍCULO
                  </StyledTitle>
                )}
              </Col>
            </Row>

            <Row className="mt-4">
              <Col md={{ size: 8, offset: 2 }}>
                <WizardForm
                  onDelete={this.deleteCedule}
                  changeData={this.changeData}
                  data={this.state.data}
                  changeType={this.changeType}
                  type={this.state.type}
                  changeStep={this.changeStep}
                  actuallyStep={this.state.step}
                  onSubmit={this.onSubmit}
                />
              </Col>
            </Row>
          </div>
          <div className="text-center mt-2">
            <img
              src={imageCedula}
              alt="cedula-azul-imagen"
              className="img-fluid img-cedula"
            />
          </div>
          <Faqs />
          <Services />
          <Testimonial />
        </Layout>
      </Fragment>
    );
  }
}

export const StyledTitle = styled.span`
  display: block;
  padding-right: 15px;
  background: ${props => props.background || "transparent"};
  text-align: ${props => props.align || "left"};
  font-family: Montserrat;
  font-size: 24px;
  font-weight: 500;
`;

const mapStateToProps = state => ({
  isInvalid: isInvalid("wizard")(state)
});

export default connect(
  mapStateToProps,
  { notify, submit }
)(App);
